import type { InitOptions } from "i18next";
import { defaultLocale, locales } from "./config";

import en from "../translations/locales/en.json";
import de from "../translations/locales/de.json";
import es from "../translations/locales/es.json";
import fr from "../translations/locales/fr.json";
import hi from "../translations/locales/hi.json";
import mi from "../translations/locales/mi.json";
import zh from "../translations/locales/zh.json";

const resources = {
  en: { translation: en },
  de: { translation: de },
  es: { translation: es },
  fr: { translation: fr },
  hi: { translation: hi },
  mi: { translation: mi },
  zh: { translation: zh },
} as const;

export const i18nConfig: InitOptions = {
  supportedLngs: [...locales],
  fallbackLng: defaultLocale,
  defaultNS: "translation",
  ns: ["translation"],
  resources,
  interpolation: { escapeValue: false },
};
